import { render } from "./MiniProgramInforMation.vue?vue&type=template&id=7b0fe4e2&scoped=true"
import script from "./MiniProgramInforMation.vue?vue&type=script&lang=js"
export * from "./MiniProgramInforMation.vue?vue&type=script&lang=js"

import "./MiniProgramInforMation.vue?vue&type=style&index=0&id=7b0fe4e2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0fe4e2"],['__file',"src/views/h5/common/sys/miniProgram/information/MiniProgramInforMation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b0fe4e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b0fe4e2', __exports__)) {
    api.reload('7b0fe4e2', __exports__)
  }
  
  module.hot.accept("./MiniProgramInforMation.vue?vue&type=template&id=7b0fe4e2&scoped=true", () => {
    api.rerender('7b0fe4e2', render)
  })

}


export default __exports__